import { useHistory, useLocation } from "react-router-dom";

/** Writes the added pages to `?with=`, one param per page, as a new history entry. */
export const usePushAdded = () => {
    const history = useHistory();
    const location = useLocation();
    return (ids) => {
        const params = new URLSearchParams(location.search);
        params.delete("with");
        ids.forEach((id) => params.append("with", id));
        history.push({ pathname: location.pathname, search: `?${params.toString()}` });
    };
};
